module.exports = __webpack_public_path__ + "img/section02.725f2f13.png";